import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DialogService } from '../../../../services/dialog.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Utils } from "../../../../utils/utils";
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: "kpiadminnewkpiform",
    templateUrl: './kpiadminnewkpi-form.component.html',
    styleUrls: ['./kpiadminnewkpi-form.component.less'],
    standalone: false
})
export class KpiAdminNewKpiFormComponent implements OnInit {

    SelectedGF: string = "";
    MersyId: string = "";
    KpiName: string = "";
    KpiDefinitionId: any;

    NEWMersyId: string = "";
    NEWKpiName: string = "";
    OpcNew: string = "0";
    isSubmitting = false;

    constructor(private http: HttpClient
        , @Inject(MAT_DIALOG_DATA) public data: any
        , @Inject('BASE_URL') private baseUrl: string
        , public dialogRef: MatDialogRef<KpiAdminNewKpiFormComponent>
        , private toastrService: ToastrService
        , private dialog: DialogService) {
        this.dialog.tthis = this;
    }

    ngOnInit(): void {
        this.MersyId = this.data.MersyId;
        this.KpiName = this.data.KpiName;
        this.KpiDefinitionId = this.data.KpiDefinitionId;
        this.SelectedGF = this.data.SelectedGF;
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onSubmit() {
        this.AddKpi();
    }

    AddKpi() {
        if (!this.isFormValid()) {
            this.toastrService.error('Please input both MersyID and Kpi Name.');
            return;
        }

        const param = {
            "OpcNew": this.OpcNew,
            "KpiDefinitionId_reference": this.KpiDefinitionId,
            "MersyId_NEW": this.NEWMersyId,
            "KpiName_NEW": this.NEWKpiName,
        };
        const url = this.baseUrl + "api/KPIManagement/Add_Kpi";
        this.isSubmitting = true;
        this.http.post<any[]>(url, param).subscribe(kpiadded => {
            this.isSubmitting = false;
            if (!Number.isNaN(kpiadded) && Number(kpiadded) > 0) {
                this.dialogRef.close({ ...param, "KpiAdded": kpiadded });
            } else {
                this.dialog.doBack = false;
                this.dialog.showErrorStringDialog('An error occurred');
                this.dialogRef.close(false);
            }
        }, error => {
            this.isSubmitting = false;
            Utils.writeLog(this.http, this.baseUrl, error);
            this.toastrService.error('Unhandled error. Please contact your admin.');
        });
    }

    isFormValid() {
        return this.NEWMersyId.trim() != "" && this.NEWKpiName.trim() != "";
    }

    onBack() {
    }
}
